import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MetricCards } from '../components/reporting/MetricCards';
import { PastDueBreakdown } from '../components/reporting/PastDueBreakdown';
import { SpeedToLeadChart } from '../components/reporting/SpeedToLeadChart';
import { OfficerTable } from '../components/reporting/OfficerTable';
import { SourceTable } from '../components/reporting/SourceTable';
import { officers, sourceMetrics } from '../data/reporting';
import { leadSources } from '../data/configuration';
export function Reporting() {
  const navigate = useNavigate();
  return <div className="space-y-5" data-id="element-480" data-mp="17zxkj71ffj1v">
      <div data-id="element-481" data-mp="1810cliahjrjd">
        <h1 className="text-lg font-semibold tracking-tight text-ink-900" data-id="element-482" data-mp="180qv6j3iaspa">Management Dashboard</h1>
        <p className="mt-0.5 text-sm text-ink-500" data-id="element-483" data-mp="132p4bbzu9p39">
          Who is behind, on which lead sources, and why — for today.
        </p>
      </div>

      <MetricCards data-id="element-484" data-mp="2xfew9o6nco80" />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3" data-id="element-485" data-mp="2xevrl960bwbx">
        <PastDueBreakdown data-id="element-486" data-mp="2xdarz54u5n77" />
        <div className="lg:col-span-2" data-id="element-487" data-mp="yfl9k5cc1im9">
          <SpeedToLeadChart title="Speed to Lead by Loan Officer" description="Time from lead creation to first contact attempt — fastest first" rows={officers.map(o => ({
          id: o.id,
          label: o.name,
          seconds: o.speedToLeadSeconds
        }))} onSelect={id => navigate(`/reporting/officer/${id}`)} data-id="element-488" data-mp="yejp5a9ffjrv" />
        </div>
      </div>

      <OfficerTable data-id="element-489" data-mp="1m5nzaesrychp" />

      <SourceTable title="Lead Source Performance" description="Company-wide performance by source — select a source to open its lead list" rows={sourceMetrics} onSelect={sourceId => navigate(`/reporting/officer/all/source/${sourceId}`)} data-id="element-490" data-mp="1m674cuxbt6eb" />

      <SpeedToLeadChart title="Speed to Lead by Lead Source" description="Where response time is slipping across the funnel" rows={sourceMetrics.map(s => ({
      id: s.sourceId,
      label: leadSources.find(ls => ls.id === s.sourceId)?.name ?? s.sourceId,
      seconds: s.speedToLeadSeconds
    }))} data-id="element-491" data-mp="212y8tilux8as" />
    </div>;
}